import { useParams } from 'react-router-dom';

import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import ButtonLink from 'shared/components/Button/ButtonLink';
import { Typography } from 'shared/components/Typography';

export const SessionsBackButton = () => {
  const { email } = useParams();

  return (
    <Spacer size="zr zr lg">
      <ButtonLink
        to={`/hde/participants/${email}/sessions`}
        data-testid="back-session-btn"
        size="xs"
        variant="ghost"
      >
        <Icon
          name={iconNames.arrowLeft}
          height="12px"
          width="14px"
          stroke="var(--fgInteractive)"
        />
        <Typography color="blue" type="small">
          Back
        </Typography>
      </ButtonLink>
    </Spacer>
  );
};
